"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRING_TABLE_OFFSET = exports.StringLayer = exports.AllegroTextAlignment = exports.TextReversal = exports.PadstackComponentType = exports.AllegroPadType = exports.AllegroBoardUnits = void 0;
exports.condExists = condExists;
exports.condExistsLt = condExistsLt;
exports.condExistsRange = condExistsRange;
var AllegroBoardUnits;
(function (AllegroBoardUnits) {
    AllegroBoardUnits[AllegroBoardUnits["IMPERIAL"] = 1] = "IMPERIAL";
    AllegroBoardUnits[AllegroBoardUnits["METRIC"] = 3] = "METRIC";
})(AllegroBoardUnits || (exports.AllegroBoardUnits = AllegroBoardUnits = {}));
var AllegroPadType;
(function (AllegroPadType) {
    AllegroPadType[AllegroPadType["THROUGH_VIA"] = 0] = "THROUGH_VIA";
    AllegroPadType[AllegroPadType["VIA"] = 1] = "VIA";
    AllegroPadType[AllegroPadType["SMD_PIN"] = 2] = "SMD_PIN";
    AllegroPadType[AllegroPadType["SLOT"] = 3] = "SLOT";
    AllegroPadType[AllegroPadType["NPTH"] = 4] = "NPTH";
})(AllegroPadType || (exports.AllegroPadType = AllegroPadType = {}));
var PadstackComponentType;
(function (PadstackComponentType) {
    PadstackComponentType[PadstackComponentType["NULL"] = 0] = "NULL";
    PadstackComponentType[PadstackComponentType["CIRCLE"] = 2] = "CIRCLE";
    PadstackComponentType[PadstackComponentType["OCTAGON"] = 3] = "OCTAGON";
    PadstackComponentType[PadstackComponentType["CROSS"] = 4] = "CROSS";
    PadstackComponentType[PadstackComponentType["SQUARE"] = 5] = "SQUARE";
    PadstackComponentType[PadstackComponentType["RECTANGLE"] = 6] = "RECTANGLE";
    PadstackComponentType[PadstackComponentType["DIAMOND"] = 7] = "DIAMOND";
    PadstackComponentType[PadstackComponentType["PENTAGON"] = 10] = "PENTAGON";
    PadstackComponentType[PadstackComponentType["OBLONG_X"] = 11] = "OBLONG_X";
    PadstackComponentType[PadstackComponentType["OBLONG_Y"] = 12] = "OBLONG_Y";
    PadstackComponentType[PadstackComponentType["HEXAGON_X"] = 15] = "HEXAGON_X";
    PadstackComponentType[PadstackComponentType["HEXAGON_Y"] = 16] = "HEXAGON_Y";
    PadstackComponentType[PadstackComponentType["TRIANGLE"] = 18] = "TRIANGLE";
    PadstackComponentType[PadstackComponentType["SHAPE_SYMBOL"] = 22] = "SHAPE_SYMBOL";
    PadstackComponentType[PadstackComponentType["FLASH"] = 23] = "FLASH";
    PadstackComponentType[PadstackComponentType["DONUT"] = 25] = "DONUT";
    PadstackComponentType[PadstackComponentType["ROUNDED_RECTANGLE"] = 27] = "ROUNDED_RECTANGLE";
    PadstackComponentType[PadstackComponentType["CHAMFERED_RECTANGLE"] = 28] = "CHAMFERED_RECTANGLE";
    PadstackComponentType[PadstackComponentType["NSIDED_POLYGON"] = 30] = "NSIDED_POLYGON";
    PadstackComponentType[PadstackComponentType["APERTURE_EXT"] = 238] = "APERTURE_EXT";
})(PadstackComponentType || (exports.PadstackComponentType = PadstackComponentType = {}));
var TextReversal;
(function (TextReversal) {
    TextReversal[TextReversal["STRAIGHT"] = 0] = "STRAIGHT";
    TextReversal[TextReversal["REVERSED"] = 1] = "REVERSED";
    TextReversal[TextReversal["UNKNOWN"] = 2] = "UNKNOWN";
})(TextReversal || (exports.TextReversal = TextReversal = {}));
var AllegroTextAlignment;
(function (AllegroTextAlignment) {
    AllegroTextAlignment[AllegroTextAlignment["LEFT"] = 0] = "LEFT";
    AllegroTextAlignment[AllegroTextAlignment["RIGHT"] = 1] = "RIGHT";
    AllegroTextAlignment[AllegroTextAlignment["CENTER"] = 2] = "CENTER";
    AllegroTextAlignment[AllegroTextAlignment["UNKNOWN"] = 3] = "UNKNOWN";
})(AllegroTextAlignment || (exports.AllegroTextAlignment = AllegroTextAlignment = {}));
var StringLayer;
(function (StringLayer) {
    StringLayer[StringLayer["BOT_TEXT"] = 0] = "BOT_TEXT";
    StringLayer[StringLayer["TOP_TEXT"] = 1] = "TOP_TEXT";
    StringLayer[StringLayer["BOT_PIN"] = 2] = "BOT_PIN";
    StringLayer[StringLayer["TOP_PIN"] = 3] = "TOP_PIN";
    StringLayer[StringLayer["TOP_PIN_LABEL"] = 4] = "TOP_PIN_LABEL";
    StringLayer[StringLayer["BOT_REFDES"] = 5] = "BOT_REFDES";
    StringLayer[StringLayer["TOP_REFDES"] = 6] = "TOP_REFDES";
    StringLayer[StringLayer["UNKNOWN"] = 7] = "UNKNOWN";
})(StringLayer || (exports.StringLayer = StringLayer = {}));
exports.STRING_TABLE_OFFSET = 0x1200;
function condExists(ver, minVer) {
    return ver >= minVer;
}
function condExistsLt(ver, maxVer) {
    return ver < maxVer;
}
function condExistsRange(ver, minVer, maxVer) {
    return ver >= minVer && ver < maxVer;
}
//# sourceMappingURL=blockStructs.js.map